<template>
  <v-dialog v-model="operatorDialog" scrollable persistent max-width="500">
    <v-card>
      <v-card-title>
        <span class="headline"> {{operatorDialogTitle}} Operatori</span>
      </v-card-title>
      <v-card-text>        
        <v-form>
          <v-container grid-list>
            <v-layout wrap>
              <v-flex xs2>
                <v-text-field 
                  label="Op. Cassa" 
                  v-model="newOperator.cashID" 
                  v-validate="'required|min_value:0|max_value:99'"
                  data-vv-name="cashID"
                  data-vv-scope="operatorForm"
                  :error-messages="errors.first('operatorForm.cashID')"            
                  required
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field            
                  label="Nome" 
                  v-model="newOperator.name" 
                  v-validate="'required'"
                  data-vv-name="name"
                  data-vv-scope="operatorForm"
                  :error-messages="errors.first('operatorForm.name')"            
                  required
                  v-if="operatorDialog" autofocus
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  label="Password"
                  v-model="newOperator.password"
                  v-validate="'required'"
                  data-vv-name="password"
                  data-vv-scope="operatorForm"
                  :error-messages="errors.first('operatorForm.password')"            
                  required
                ></v-text-field>
              </v-flex>
                <v-flex xs12>
                  <v-radio-group 
                    v-model="rightsHelper"
                    label="Permessi"
                    :error-messages="errors.first('operatorForm.permissions')" 
                  >
                    <v-layout>
                      <v-flex>
                        <v-radio label="Proprietario" value="owner"></v-radio>
                        <v-radio label="Camerieri" value="waiter"></v-radio>
                        <v-radio label="Cassieri" value="cashier"></v-radio>
                      </v-flex>

                      <v-flex class="ml-5">
                        <v-radio label="Camerieri/Cassieri" value="waiter-cashier"></v-radio>
                        <v-radio label="Addetto Backoffice" value="backoffice"></v-radio>
                        <v-radio label="Specializzato" value="custom"></v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                  <v-expansion-panel class="noshadow">
                  <v-expansion-panel-content >
                    <template v-slot:header>
                        <div>
                          Opzioni avanzate...
                        </div>                     
                    </template>
                      <v-treeview
                        ref="treeview"
                        class="mt-2" 
                        :items="operatorRights"
                        selectable
                        item-key="code"
                        v-model="newOperator.permissions"
                        v-validate="'required'"
                        data-vv-name="permissions"
                        data-vv-scope="operatorForm"                        
                        required
                      ></v-treeview>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                </v-flex>                
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error darken-1" flat @click="closeOperatorDialog">Annulla</v-btn>
        <v-btn color="success darken-1" flat @click="saveOperator">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import _ from "lodash";
import uuidv4 from "uuid/v4";
export default {
  name: 'operatorDialog',
  props:[
      'operatorDialog', 'newOperator', 'operatorDialogTitle', 'operators'
  ],
  data(){
    return {
      operatorRole: [
        { id: 'owner', permissions: ['CONTO','COMANDA','MAIN','GESTIONE','MAGLITE','RICETT.','FIDELITY','MOV.CASSA','ANDROID','CASHDRAWER','FATREP']},
        { id: 'waiter', permissions: ['ANDROID',"fidelity_visualizzare_movimenti_riservati"]},
        { id: 'cashier', permissions: ['MOV.CASSA','COMANDA','CONTO']},
        { id: 'waiter-cashier', permissions: ['ANDROID','MOV.CASSA','COMANDA','CONTO']},
        { id: 'backoffice', permissions: ['CASHDRAWER','FATREP','RICETT']},
        { id: 'custom', permissions: [] }
      ]
    }
  },
  computed: {
    operatorRights: function(){

      let operatorRights = utils.clone(this.$store.getters.OperatorsRights);
      let parentArray = operatorRights.filter( (value, index, self) => {
          return index === self.findIndex((element) => {
              return element.context === value.context; 
          });        
      });

      var operatorRightsTree = []

      operatorRightsTree = parentArray.map((element, index) => {
        let mappedParents = {};
        mappedParents.id = index;
        mappedParents.code = element.context;
        mappedParents.name = element.context;
        mappedParents.children = [];          
        return mappedParents;   
      });

      var indexHelper = operatorRightsTree.length;
      
      operatorRights.forEach((right, index) => {
        operatorRightsTree.forEach((parentRight, ) => {
          if (parentRight.name === right.context) {
            right.id = index + indexHelper;
            right.name = right.descr;
            parentRight.children.push(right);
          }
        });
      });

      return operatorRightsTree
    },
    rightsHelper: {
      get() {
        return this.newOperator.role;
      },
      set(value) {
        if ( typeof value == 'string') {
          this.newOperator.role = value;
           let role = this.operatorRole.find(element => element.id == value);
           this.newOperator.permissions = role.permissions;
        }
      }
    }
  },
  methods: {
    atLeastOneValidation() {
      //CUSTOM VALIDATION RULE FOR SERIAL NUMBER FIELD ON TERMINAL FORM
      this.$validator.extend('atleastone', {
          getMessage(field, args) {
              return "Al meno un permesso deve essere selezionato."
          },
          validate: (value, args) => {               
              return value || options.some((option) => option[testProp]);
          }
      });
    },
    closeOperatorDialog() {
        this.$validator.reset();
        this.newOperator.id = "";
        this.newOperator.CashID = 1;
        this.newOperator.name = "";
        this.newOperator.password = "";       
        this.newOperator.permissions = [];    
        this.$refs.treeview.updateAll(false)
        this.$emit('closeOperatorDialog', false);
    },
    saveOperator() {
        var vm = this;
        var done = false;
        var message;

        this.$validator.validate('operatorForm.*').then((result) => {
            if (result) {
              if (this.newOperator.id) {
                  //find the object in the array served by the DB and update it.
                  this.operators.forEach((operator, index, operators) => {
                  if (operator.id == vm.newOperator.id && !done) {
                      vm.newOperator.cashID = parseInt(vm.newOperator.cashID);
                      vm.operators.splice(index, 1, utils.clone(vm.newOperator));
                      done = true;
                  }
                  message = 'Operatore modificato. Ricorda di salvare le impostazioni.';
                  });
              } else{
                  //push a new object in the object array
                  this.newOperator.id = uuidv4();
                  vm.newOperator.cashID = parseInt(vm.newOperator.cashID);
                  vm.operators.push(utils.clone(vm.newOperator));
                  message = 'Operatore inserito. Ricorda di salvare le impostazioni.';
              }          
            this.closeOperatorDialog();
            this.$store.dispatch('PUSH_MESSAGE', message);
            }
        });
    },
  }
}
</script>

<style lang="stylus">
.noborder 
  .v-input__control
    .v-input__slot:before
      border: none !important

.noshadow
    box-shadow: none !important
</style>


// WEBPACK FOOTER //
// src/components/common/OperatorDialog.vue